module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [
    [_c('v-tabs', {
      attrs: {
        "color": "#e1e1e1"
      },
      model: {
        value: (_vm.tab),
        callback: function($$v) {
          _vm.tab = $$v
        },
        expression: "tab"
      }
    }, [_c('v-tabs-slider'), _vm._v(" "), _c('v-tab', {
      key: 1,
      staticClass: "primary--text",
      attrs: {
        "ripple": ""
      }
    }, [_vm._v("\n          Client Onboarding\n        ")]), _vm._v(" "), _c('v-tab', {
      key: 2,
      staticClass: "primary--text",
      attrs: {
        "ripple": ""
      }
    }, [_vm._v("\n          Select Plan And Vendors\n        ")])], 1), _vm._v(" "), _c('v-tabs-items', {
      attrs: {
        "touchless": ""
      },
      model: {
        value: (_vm.tab),
        callback: function($$v) {
          _vm.tab = $$v
        },
        expression: "tab"
      }
    }, [_c('v-tab-item', {
      key: 1
    }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-md-center",
      attrs: {
        "pb-3": ""
      }
    }, [_c('h2', [_c('v-icon', [_vm._v("arrow_downward")]), _vm._v("\n                      Fill info about the deceased\n                    ")], 1)]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-subheader', {
      staticClass: "required"
    }, [_vm._v("Client:")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('dfs-client-add-form', {
      attrs: {
        "selected-client": _vm.selectedClient
      },
      on: {
        "namechanged": _vm.onNameChanged,
        "valid:changed": _vm.onFormValidate
      }
    })], 1)], 1), _vm._v(" "), _c('dfs-forms', {
      attrs: {
        "caseid": _vm.caseid
      },
      on: {
        "valid:changed": _vm.onFormValidate
      }
    })], 1)], 1), _vm._v(" "), _c('DfsServiceAgreementCheckList', {
      on: {
        "agreement:status": _vm.checkAgreementStatus,
        "valid:changed": _vm.onFormValidate
      }
    }), _vm._v(" "), _c('DfsServiceAgreementClientData', {
      attrs: {
        "clientName": _vm.clientName
      },
      on: {
        "clientdata:input": _vm.checkClientDataStatus,
        "valid:changed": _vm.onFormValidate
      }
    }), _vm._v(" "), _c('h3', [_vm._v("Draw Client Signature")]), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "top": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "flat": "",
        "icon": ""
      },
      on: {
        "click": _vm.clearSignature
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("undo")])], 1), _vm._v("\n                Clear signature\n              ")], 1), _vm._v(" "), _c('div', {
      staticClass: "sign-pad"
    }, [_c('VueSignaturePad', {
      ref: "signaturePad",
      attrs: {
        "height": "250px",
        "width": "500px"
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "color": "primary",
        "block": "",
        "loading": _vm.loading.SaveCaseBtn,
        "disabled": _vm.disabled.SaveCaseBtn
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveCase.apply(null, arguments)
        }
      }
    }, [_vm._v("\n                Save case\n              ")])], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
      attrs: {
        "open": _vm.dialogOpen,
        "message": _vm.dialogMessage
      },
      on: {
        "closedialog": function($event) {
          _vm.dialogOpen = false
        }
      }
    })], 1), _vm._v(" "), _c('v-tab-item', {
      key: 2
    }, [_c('SelectPlanAndVendors', {
      attrs: {
        "case-id": _vm.caseid,
        "editable": ""
      }
    })], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-574097ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnboardClient.vue
// module id = 965
// module chunks = 1